import { Flex, Spinner } from '@chakra-ui/react'

export const Loader = () => {
    return (
        <Flex justifyContent={'center'} alignItems={'center'} flexShrink={1} h={'full'} minH={'full'}>
            <Spinner color={'state.primary'} size={'lg'} />
        </Flex>
    )
}
